<div class="switch-solution-modal" mat-dialog-content>
  <header class="modal-header">
    <h2 class="title-large font-brand weight-bold">{{ 'Cambiar de soluciones' | translate }}</h2>
    <p class="body-medium text-secondary">
      {{ 'Elige a cuál quieres ir. Entras con el mismo workspace, sin volver a iniciar sesión.' | translate }}
    </p>
  </header>

  <div class="solution-list">
    @if (cargando()) {
    <!--
      El diálogo abre antes de tener la lista: el cargando va acá, donde el
      usuario está mirando, y no como una espera sin señal antes de abrir.
    -->
    <div class="cargando-soluciones" role="status" [attr.aria-label]="'Cargando' | translate">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
    } @else {
    @for (solucion of soluciones(); track solucion.id) {
    <app-solution-option [solucion]="solucion" [seleccionada]="estaSeleccionada(solucion)"
      (elegir)="elegir($event)" />
    } @empty {
    <p class="body-medium text-secondary sin-soluciones">
      {{ 'Este workspace no tiene otras soluciones habilitadas.' | translate }}
    </p>
    }
    }
  </div>

  <div class="switch-solution-actions" mat-dialog-actions>
    <button type="button" class="outlined" (click)="cancelar()">{{ 'Cancelar' | translate }}</button>
    <button type="button" class="filled" [disabled]="!puedeContinuar()" (click)="continuar()">
      {{ 'Continuar' | translate }}
    </button>
  </div>
</div>
